import React, { useEffect, useState } from "react";
import { Image, Row, Col, Container } from "react-bootstrap";
import "../../assets/css/style.css";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

const Header = () => {
  const { t } = useTranslation();
  const cookies = new Cookies();

  return (
    <>
      <div>
        <div>
          {/* Content Area With Outlet */}
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Header;
